import { Box, Divider, Center } from "@chakra-ui/react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Footer = () => (
  <Center>
    <Box m={2}>
      <a href="https://www.linkedin.com/in/rdotsilva/">
        <LinkedInIcon />
      </a>
    </Box>
  </Center>
);

export default Footer;
